export default "__VITE_ASSET__DQPiytlG__"